module.exports = __webpack_public_path__ + "static/media/Koffie-Vriesdroog.199f073d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Koffie-Vriesdroog.jpg
// module id = 320
// module chunks = 0